import { useMemo } from "react";
import type { CSSProperties } from "react";
import { useScheduleContext } from "../context/useScheduleContext";
import { usePreferences } from "../../../../Settings/Configuration/hooks/usePreferences";
import { SCHEDULE_PREFERENCE_KEYS } from "../../constants/scheduleTypes";
import { palette } from "../../../../Settings/Configuration/Schedule/Team/Settings/Shift/colors";

export const useOpenShiftPreferenceStyle = () => {
    const { type } = useScheduleContext();
    const preferences = usePreferences(SCHEDULE_PREFERENCE_KEYS[type]);

    return useMemo(() => {
        const caseDisplay = preferences?.shiftCaseDisplay || "normal";
        const shiftColors = palette?.openShift?.[preferences?.colors?.openShift ?? 0];
        return {
            textTransform: (caseDisplay === "normal" ? "none" : caseDisplay) as CSSProperties["textTransform"],
            backgroundColor: shiftColors?.bg,
            borderColor: shiftColors?.border,
        };
    }, [preferences]);
};
